import React, { useContext } from 'react';
import { useMutation, useQueryClient } from "react-query";
import { useDispatch } from "react-redux";

import Button from "../../components/Button";
import Typography from "../../components/Typography";
import MainLoader from "../../components/Loader/MainLoader";
import { useUserById } from '../../hooks/user';
import { cancelInvite, resendInvite } from "../../api/mutations/user";
import {AlertContext} from "../../components/SuccessOrFailedModal";
import {closeExplore, closeKeyInsightsModal} from "../../redux/reducers/dashboard";
import { BANNER_DETAILS, USER_MANAGEMENT } from '../../hooks/utils/constants';
import { useSearchParams, useNavigate } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';

const UserDetails = ({ id: user_id, role, activeTab }) => {
    const [popup] = useContext(AlertContext);
    const dispatch = useDispatch();
    let resendInviteMutation = useMutation(resendInvite);
    let cancelMutation = useMutation(cancelInvite);
    const queryClient = useQueryClient()
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    user_id = user_id || searchParams.get("user_id");
    role = role || searchParams.get("role");
    activeTab = activeTab || searchParams.get("activeTab");

    // const dispatch = useDispatch()
    let { data, isFetching } = useUserById(user_id, role, activeTab);

    const createShortName = (name) => {
        let str = name;
        let matches = str.match(/\b(\w)/g); // ['J','S','O','N']
        return matches.join(''); // JSON
    }

    const customerRoles = [
        "Customer Admin",
        "Customer Leader",
        "Pentest Manager",
        "Pentest Overseer",
        "Point of Contact"
    ];

    const siembaRoles = [
        "Siemba Tester",
        "Siemba Admin"
    ]

    const formatRole = (userData) => {
        if (userData) {
            let role = userData?.role?.split('_');
            const capitalizeRole = role.map((word) => {
                return word.charAt(0).toUpperCase() + word.substring(1);
            });
            role = capitalizeRole.join(" ");
            if (role === 'Asset Poc') {
                return "Point of Contact";
            }
            return role;
        }
    }

    const handleInviteCancellation = async () => {
        let payload = {
            user_id,
            role,
            activeTab
        }
        popup({
            title: "Are you sure?",
            description: `The invite sent to ${data?.first_name} ${data?.last_name} (${data?.email}) will be cancelled.`,
            okayText: "Yes",
            cancelText: "Cancel"
        }).then(async () => {
            await cancelMutation.mutateAsync(payload);
            queryClient.invalidateQueries(USER_MANAGEMENT)
            queryClient.invalidateQueries(BANNER_DETAILS)
            // refreshPage();
            // popup({
            //     title: <span>Your invitation <nobr>is cancelled</nobr></span>,
            //     description: `Your invitation has been cancelled.`,
            //     variant: "success"
            // });
        })
        dispatch(closeExplore());
        dispatch(closeKeyInsightsModal());
    }

    const handleResendInvitation = async () => {
        let payload = {
            user_id,
            role,
            activeTab
        }
        popup({
            title: "Are you sure?",
            description: `${data?.first_name} ${data?.last_name} is already invited as the ${formatRole(data) === 'Siemba Admin' ? 'Platform Admin' : formatRole(data)}. Re sending will share the invite again.`,
            okayText: "Yes",
            cancelText: "Cancel"
        }).then(async () => {
            await resendInviteMutation.mutateAsync(payload);
        });
        dispatch(closeExplore());
        dispatch(closeKeyInsightsModal());
    }

    return (
        <div className='user-details-side'>
          {isFetching && <MainLoader/>}
            <div className="absolute top-2 right-2 sm:hidden">
              <CloseIcon 
                onClick={() => navigate(-1)} 
                className={"text-body cursor-pointer"}
              />
            </div>
            <div className='user-details'>
                <div className='profile-pic'>
                    {
                        data?.profile_picture ? 
                            <img src={data && data?.profile_picture} alt={createShortName(`${data?.first_name} ${data?.last_name}`)} />
                        :
                            <div>
                                {createShortName(`${data?.first_name} ${data?.last_name}`)}
                            </div>
                    }
                </div>
                <div className='details'>
                    <Typography variant={"h5"} className={"font-bold"}>{`${data?.first_name} ${data?.last_name}`} <span className='company-name'>{data?.company_name ? `(${data?.company_name})` : ''}</span></Typography>
                    <p>{data?.email}</p>
                </div>
            </div>
            <div className='role-details'>
                {
                    data?.status === "inactive" ?
                        <p className='current-role-info'>{`${data?.first_name} ${data?.last_name} is invited as the ${formatRole(data) === 'Siemba Admin' ? 'Platform Admin' : formatRole(data)}`}</p>
                    :
                        <p className='current-role-info'>{`${data?.first_name} ${data?.last_name} is a ${formatRole(data) === 'Siemba Admin' ? 'Platform Admin' : formatRole(data)}`}</p>
                    
                }
                <div className='current-role'>
                    <p>Access</p>
                    <div className='role'>
                        {
                            activeTab === "customers" ?
                                <ul>
                                    {customerRoles.map((role, index) => (
                                        <li key={index+1} className={role === formatRole(data) ? 'current' : ''}>{role}</li>
                                    ))}
                                </ul>
                            :
                                <ul>
                                    {siembaRoles.map((role, index) => (
                                        <li key={index+1} className={role === formatRole(data) ? 'current' : ''}>{role === "Siemba Admin" ? 'Platform Admin' : role}</li>
                                    ))}
                                </ul>
                        }
                    </div>
                </div>
            </div>
            {
                data?.status === "inactive" &&
                    <div className='invite-actions'>
                        <Button onClick={() => handleInviteCancellation()}
                                className={"!bg-tertiary-600 w-full sm:w-auto cancel-invite"}>Cancel Invite</Button>
                        <Button onClick={() => handleResendInvitation()} variant={"contained"}
                    className={`!bg-primary-500 resend-invite-btn`}>Re-Send Invite</Button>
                    </div>
            }
        </div>
    );
};

export default UserDetails;
